import React, { useEffect, useState } from "react";
import {
  VariantControl,
  VariantDot,
  VariantType,
} from "../../components/variant/VariantControl";
import { NewPropertyState } from "../../../usePropertyStateV2";
import { ComboBoxOptionType, DiscreteInput } from "../../components/input";
import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuTrigger,
} from "@/components/ui/context-menu";
import {
  JUSTIFY_CONTENT_OPTIONS,
  TEXT_ALIGN_OPTIONS,
} from "../../components/variant/variantOptions";
import { PropertyType } from "@/tailwind/tailwindUtils";

// TODO: Split all fields out from the TailwindStylingPanelV2.tsx file like this

interface TextAlignProps {
  textAlignState: NewPropertyState;
  pickTailwindClassForProperty: (props: {
    option: ComboBoxOptionType;
    propertyType: PropertyType;
    setTemporaryDraggingValue: (value: string | null) => void;
    variant?: string | null;
  }) => void;
  clearTailwindClassForProperty: (props: {
    propertyType: PropertyType;
    setTemporaryDraggingValue: (value: string | null) => void;
    variant?: string | null;
  }) => void;
}

const TextAlignField: React.FC<TextAlignProps> = React.memo(
  ({
    textAlignState,
    pickTailwindClassForProperty,
    clearTailwindClassForProperty,
  }) => {
    return (
      <ContextMenu>
        <ContextMenuTrigger asChild>
          <div className="flex flex-1 w-full items-center gap-2 justify-between relative">
            <VariantDot valueByVariant={textAlignState.valueByVariant} />
            <DiscreteInput
              options={TEXT_ALIGN_OPTIONS}
              onOptionSelected={(discreteOption) => {
                pickTailwindClassForProperty({
                  option: discreteOption.option,
                  propertyType: PropertyType.TEXT_ALIGN,
                  setTemporaryDraggingValue:
                    textAlignState.setTemporaryDraggingValue,
                });
              }}
              selected={textAlignState.propertyValue}
              set={textAlignState.isSet}
              onDeselect={() => {
                clearTailwindClassForProperty({
                  propertyType: PropertyType.TEXT_ALIGN,
                  setTemporaryDraggingValue:
                    textAlignState.setTemporaryDraggingValue,
                });
              }}
              className="w-full"
            />
          </div>
        </ContextMenuTrigger>
        <ContextMenuContent className="p-0 border-none">
          <VariantControl
            valueByVariant={textAlignState.valueByVariant}
            onVariantChange={(variant: VariantType, value) => {
              const option = TEXT_ALIGN_OPTIONS.find(
                (opt) => opt.key === value,
              );
              if (option) {
                pickTailwindClassForProperty({
                  option: option.option,
                  propertyType: PropertyType.TEXT_ALIGN,
                  setTemporaryDraggingValue:
                    textAlignState.setTemporaryDraggingValue,
                  variant,
                });
              }
            }}
            onClearVariant={(variant: VariantType) => {
              clearTailwindClassForProperty({
                propertyType: PropertyType.TEXT_ALIGN,
                setTemporaryDraggingValue:
                  textAlignState.setTemporaryDraggingValue,
                variant,
              });
            }}
            currentFlexDirection={""}
            currentJustifyContent={""}
            currentAlignItems={""}
            controlType="text-align"
          >
            {(variant, expanded, setExpanded) => {
              if (!expanded || !variant) return null;
              const variantValue =
                textAlignState.valueByVariant[variant]?.value || "";
              return (
                <DiscreteInput
                  options={TEXT_ALIGN_OPTIONS}
                  onOptionSelected={(discreteOption) => {
                    pickTailwindClassForProperty({
                      option: discreteOption.option,
                      propertyType: PropertyType.TEXT_ALIGN,
                      setTemporaryDraggingValue:
                        textAlignState.setTemporaryDraggingValue,
                      variant,
                    });
                  }}
                  selected={variantValue}
                  set={!!variantValue}
                  onDeselect={() => {
                    clearTailwindClassForProperty({
                      propertyType: PropertyType.TEXT_ALIGN,
                      setTemporaryDraggingValue:
                        textAlignState.setTemporaryDraggingValue,
                      variant,
                    });
                  }}
                />
              );
            }}
          </VariantControl>
        </ContextMenuContent>
      </ContextMenu>
    );
  },
);

export default TextAlignField;
